export const getCustomNodeValuesFromHtml = (htmlString: string): string[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const customNodes = doc.querySelectorAll('span[data-custom-node]');
  return Array.from(customNodes).map(
    (node) => node.getAttribute('value') || '',
  );
};
